import {
    COMPARADOR_LOAD_BRANDS_BEGIN,
    COMPARADOR_LOAD_BRANDS_FAILURE,
    COMPARADOR_LOAD_BRANDS_SUCCESS
} from './constants'
import axios from 'axios'
import { getResponseMapped } from '../utils/utils'
import initialState from './initialState'

export function loadBrands(endpoint, inputValue, index) {
    return (dispatch) => {
        if (!endpoint || index === undefined) {
            return null
        }

        dispatch({ type: COMPARADOR_LOAD_BRANDS_BEGIN })

        return new Promise((resolve, reject) => {
            const doRequest = axios.get(endpoint)
            doRequest.then(
                (res) => {
                    const responseData = getResponseMapped(res.data.data)
                    dispatch({
                        type: COMPARADOR_LOAD_BRANDS_SUCCESS,
                        data: responseData,
                        index: index
                    })

                    let aux = res.data.data.filter((dataValue) => dataValue.name.includes(inputValue.toUpperCase()))
                    resolve(getResponseMapped(aux))
                },
                (err) => {
                    dispatch({
                        type: COMPARADOR_LOAD_BRANDS_FAILURE,
                        data: { error: err },
                        index: index
                    })
                    reject(err)
                }
            )
        })
    }
}

export function reducer(state = initialState, action) {
    const { index, data, type } = action
    if (index === undefined) return state
    switch (type) {
        case COMPARADOR_LOAD_BRANDS_BEGIN:
            return {
                ...state,
                brands: {
                    ...state.brands,
                    [`${index}`]: {
                        isPending: true,
                        hasError: null,
                        data: null
                    }
                }
            }

        case COMPARADOR_LOAD_BRANDS_SUCCESS:
            return {
                ...state,
                brands: {
                    ...state.brands,
                    [`${index}`]: {
                        isPending: false,
                        hasError: null,
                        data: data
                    }
                }
            }

        case COMPARADOR_LOAD_BRANDS_FAILURE:
            return {
                ...state,
                brands: {
                    ...state.brands,
                    [`${index}`]: {
                        isPending: false,
                        hasError: data.error,
                        data: null
                    }
                }
            }
        default:
            return state
    }
}

